<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">
  <div class="mx-auto flex w-full flex-wrap p-4">
    <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
      <div>
        <div class="flex items-center gap-1">
            <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
                <button mat-icon-button color="primary">
                <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
                </button>
            </div>
            <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
                <div class="p-4">
                <p>Unidad principal de la estructura organizativa. Representa una razón social distinta con información
                    fiscal y legal propia. Se debe crear una nueva compañía cuando se trata de una entidad financiera o
                    legal diferente dentro del ecosistema AVE.</p>
                </div>
            </mat-menu>
            <h2 class="text-xl font-semibold leading-8 tracking-tight">
                Activos
            </h2>
        </div>
        <div class="text-sm text-secondary font-medium tracking-tight">
            Activa/inactiva, crea, actualiza y elimina los <b>activos</b> que operan dentro de AVE.
        </div>
      </div>
      <!-- Header -->
      <div class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
        <div class="flex shrink-0">
            <!-- Title -->
            <!--<div class="text-3xl font-extrabold tracking-tight">Condiciones de Cambio</div> -->
            <app-status-filters [selectedStatuses]="selectedStatuses" [showStatus]="[1,0]" [typeFilter]="'master'"
                    (selectionFilterApply)="getList()">
                </app-status-filters>
        </div>
        <!-- Actions -->
        <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
            <!-- Add button (only icon) -->
            <button mat-icon-button color="primary" (click)="openModal()" matTooltip="Nuevo Registro">
                <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
            </button>
        </div>
      </div>
    </div>
    <div class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
      <!-- Main Content (Table and Paginator) -->
      <div class="pt-1 mx-6">
        <!-- Tabla -->
        <div class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
          <!-- Header -->
          <div class="overflow-auto flex-1 dark:bg-gray-900">
            <table class="w-full bg-transparent" mat-table [dataSource]="dataSource" matSort
                (matSortChange)="changeSort($event)" matSortDisableClear multiTemplateDataRows>
                
                <!-- Nombre -->
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Nombre</th>
                    <td mat-cell *matCellDef="let element" class="text-sm uppercase leading-tight">
                        <b class="f-10">{{element.code}}</b><br>
                        {{ element.name }}</td>
                </ng-container>

                <!-- Class -->
                <ng-container matColumnDef="quantity">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Cantidad</th>
                    <td mat-cell *matCellDef="let element" class="text-sm uppercase">
                        {{ element.quantity}}
                    </td>
                </ng-container>
                

                <!-- Estado -->
                <ng-container matColumnDef="statusId">
                    <th mat-header-cell *matHeaderCellDef>Estado</th>
                    <td mat-cell *matCellDef="let element">
                        <mat-slide-toggle class="custom-slide-toggle primary" [checked]="element.statusId == 1"
                            [(ngModel)]="element.statusId" [color]="'success'"
                            (ngModelChange)="onStatusChange($event, element, 'S')">
                        </mat-slide-toggle>
                    </td>
                </ng-container>
    
                <!-- Acciones -->
                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef class="px-6 py-3 text-left"></th>
                    <td mat-cell *matCellDef="let element" class="px-6 py-3 text-left">
                        <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #actionMenu="matMenu">
                            <button mat-menu-item (click)="openModal(element)">
                                <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                                <span>Editar Registro</span>
                            </button>
                            <button mat-menu-item (click)="openDeleteDialog(element)">
                                <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                                <span>Eliminar Registro</span>
                            </button>
                        </mat-menu>
                    </td>
                </ng-container>
    
                <!-- Header Row -->
                <tr mat-header-row *matHeaderRowDef="displayedColumns" class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>
    
                <!-- Fila principal -->
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="border-b"></tr>
            </table>
            </div>
            <div *ngIf="this.dataSource.data.length === 0" class="border-t p-8 text-center text-1xl sm:p-10">Lo sentimos, no hay registros para mostrar.
            </div>
        </div>

        <!-- Paginación debería asignar valor a this.pageSize--> 
        <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
            <mat-paginator class="z-10" [pageSizeOptions]="[50, 100, 150, 200]" showFirstLastButtons [length]="totalItems"
                [pageSize]="pageSize"  (page)="changePage($event)"></mat-paginator>
        </div>
      </div>   
    </div>

    <!-- Modales -->
    <ng-template #actionModal>
        <h2 mat-dialog-title class="text-lg font-bold mb-1">{{ (this.id == null ? 'Nuevo' : 'Editar')}} Registro</h2>
        <mat-dialog-content class="modal-content">
            <form #modalForm="ngForm">
                <div class="grid grid-cols-2 gap-y-2 gap-x-4 items-center">
                    <mat-form-field appearance="fill" class="w-full">
                        <mat-label>Código</mat-label>
                        <input matInput [(ngModel)]="currentAsset.code" name="code" [readonly]="this.id != null"  [disabled]="this.id != null" required>
                    </mat-form-field>
                    
                    <!-- @if(this.id == null){ -->
                    <!-- <mat-form-field appearance="fill" class="w-full">
                        <mat-label>Código Externo</mat-label>
                        <input matInput [(ngModel)]="currentAsset.excode" name="externalKeys" required>
                    </mat-form-field> -->
                    <!-- } -->

                    <mat-form-field appearance="fill" class="w-full">
                        <mat-label>Nombre</mat-label>
                        <input matInput [(ngModel)]="currentAsset.name" name="name" oninput="this.value = this.value.toUpperCase()" required>
                    </mat-form-field>

                      <mat-form-field appearance="fill" class="w-full">
                        <mat-label>Capacidad de Peso</mat-label>
                        <input type="number" matInput [(ngModel)]="currentAsset.loadCapacity" name="loadCapacity" oninput="this.value = this.value.toUpperCase()" required>
                    </mat-form-field>

                      <mat-form-field appearance="fill" class="w-full">
                        <mat-label>Cantidad</mat-label>
                        <input type="number" matInput [(ngModel)]="currentAsset.quantity" name="quantity" oninput="this.value = this.value.toUpperCase()" required>
                    </mat-form-field>


                    <mat-form-field appearance="fill" [ngClass]="id== null ? 'col-span-2' : 'w-full'">
                        <mat-label>Grupo</mat-label>
                        <mat-select [(ngModel)]="currentAsset.assetGroupId" name="assetGroup" multiple required>
                            @for (group of groupFilterList; track group) {
                            <mat-option [value]="group._id">
                                {{ group.name }}
                            </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>

                        <mat-form-field appearance="fill" [ngClass]="id== null ? 'col-span-2' : 'w-full'">
                            <mat-label>Compañía</mat-label>
                            <mat-select [(ngModel)]="currentAsset.companiesIds" name="companiesIds" multiple required>
                                @for (company of companyFilterList; track company) {
                                <mat-option [value]="company._id">
                                    {{ company.name }}
                                </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                </div>
            </form>
        </mat-dialog-content>
        <mat-dialog-actions class="modal-actions flex justify-end">
            <button mat-button mat-dialog-close class="align-left">Cancelar</button>
            <button mat-raised-button color="primary" (click)="onSubmit()"
                [disabled]="!modalForm.valid">Guardar</button>
            </mat-dialog-actions>
    </ng-template>

    <ng-template #deleteDialog let-data>
        <div class="flex items-start space-x-2 mb-4">
            <div class="flex items-center">
                <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-red-500 ml-4 mt-6"
                style="font-size: 32px;"></mat-icon>
            </div>
            <div class="grid">
                <h2 mat-dialog-title class="text-lg font-bold mb-1">Confirmar eliminación</h2>
                <mat-dialog-content class="modal-content mt-0">
                    <p>¿Está seguro que desea eliminar el registro?</p>
                </mat-dialog-content>
            </div>
        </div>
        <mat-dialog-actions class="modal-actions flex justify-end">
            <button mat-button mat-dialog-close class="align-left">Conservar</button>
            <button mat-raised-button color="warn" [mat-dialog-close]="true">Eliminar</button>
        </mat-dialog-actions>
    </ng-template>
  </div>
  <app-filter
  (onFilterEvent)="onFilter()"
  (onCleanEvent)="clearFilters()"
  (onPanelOpened)="onFilterPanelOpened()"
>
<app-configuration-filters [form]="form" [company]="true" [groupsActiveControl]="true" [loadData]="loadFiltersData"></app-configuration-filters>
</app-filter>
</mat-sidenav-container>